import { ADJECTIVES, NOUNS } from './slugDict';

/** Generate a human-readable reference slug, e.g. `smiling-otter-42`. */
export function generateReferenceSlug(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)] as string;
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)] as string;
  const num = Math.floor(Math.random() * 99) + 1;
  return `${adj}-${noun}-${num}`;
}
